module.exports = __webpack_public_path__ + "static/media/faces-pain-scale.e89d1a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/PainRating/faces-pain-scale.png
// module id = 947
// module chunks = 0